export function extendPrototypes(): void {
    String.prototype.equalsIgnoreCase = function (this: string, stringToCompare: string): boolean {
        return this.toLowerCase() === stringToCompare.toLowerCase();
    };
}
